import styled from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { TagItemViewWrapper } from 'core/components/bTag/styles';

export const CanonicalDomainModalWrapper = styled.div.attrs({
  className: "canonical-domain-modal",
})`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 300100;
  background: ${({ theme }) => theme.modal.backgroundColor};
  user-select: none;
  overflow: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

  ${TagItemViewWrapper} {
    display: inline-flex;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.596);
  }
`;

export const CanonicalDomainModalContainer = styled(FlexBox).attrs({
  className: "--container",
})`
  flex-direction: column;
  width: 1152px;
  margin: 40px auto 0 auto;
  max-height: calc(100vh - 80px);

  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;
    position: relative;
    max-height: calc(100vh - 40px);

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${({ theme }) => `linear-gradient(transparent, ${theme.app.backgroundColor}) 70%`};
      height: 10px;
      z-index: 10;
      pointer-events: none;
    }
  }
`;

export const ScrollableDomainsContainer = styled.div`
  flex: 1;    
  padding: 8px 0;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;

  /* Стили для скроллбара */
  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

`;

export const SearchInputWrapper = styled(FlexBox)`
  background: ${({ theme }) => theme.tagSearch.background};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 16px;
  
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;
    width: 100%;
    background: transparent;
    outline: none;
    color: ${({ theme }) => theme.tagSearch.inputColor};

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color}
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    background: ${({ theme }) => theme.tags.modal.search.bg};
    align-items: center;
    border: none;
    width: calc(100%);
    
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 8px;
      * {
        fill: ${({ theme }) => theme.navigationBar.search.svg} !important;
      }
    }
  }
`;

export const SearchInput = styled.input.attrs({ className: "--input" })`
  color: ${({ theme }) => theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;
  padding: 14px 0px 14px 2px;

  ::placeholder {
    color: ${({ theme }) => theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;
    height: initial;
    ::placeholder {
      color: #666;
    }
  }
`;

export const SelectedDomainsWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SelectedDomainsTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
`;

export const SelectedDomainsContainer = styled(FlexBox)`
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: 150px;
    overflow-y: auto;
  }
`;

export const DomainsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

export const DomainsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  align-items: self-end;
  overflow-x: hidden;
  overflow-y: visible;
`;
import styled from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { TagItemViewWrapper } from 'core/components/bTag/styles';

export const CanonicalDomainModalWrapper = styled.div.attrs({
  className: "canonical-domain-modal",
})`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 300100;
  background: ${({ theme }) => theme.modal.backgroundColor};
  user-select: none;
  overflow: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

  ${TagItemViewWrapper} {
    display: inline-flex;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.596);
  }
`;

export const CanonicalDomainModalContainer = styled(FlexBox).attrs({
  className: "--container",
})`
  flex-direction: column;
  width: 1152px;
  margin: 40px auto 0 auto;
  max-height: calc(100vh - 80px);

  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;
    position: relative;
    max-height: calc(100vh - 40px);

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${({ theme }) => `linear-gradient(transparent, ${theme.app.backgroundColor}) 70%`};
      height: 10px;
      z-index: 10;
      pointer-events: none;
    }
  }
`;

export const ScrollableDomainsContainer = styled.div`
  flex: 1;    
  padding: 8px 0;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;

  /* Стили для скроллбара */
  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #707070;
  }

`;

export const SearchInputWrapper = styled(FlexBox)`
  background: ${({ theme }) => theme.tagSearch.background};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 16px;
  
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;
    width: 100%;
    background: transparent;
    outline: none;
    color: ${({ theme }) => theme.tagSearch.inputColor};

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color}
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    background: ${({ theme }) => theme.tags.modal.search.bg};
    align-items: center;
    border: none;
    width: calc(100%);
    
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 8px;
      * {
        fill: ${({ theme }) => theme.navigationBar.search.svg} !important;
      }
    }
  }
`;

export const SearchInput = styled.input.attrs({ className: "--input" })`
  color: ${({ theme }) => theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;
  padding: 14px 0px 14px 2px;

  ::placeholder {
    color: ${({ theme }) => theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px;
    border-bottom: none;
    height: initial;
    ::placeholder {
      color: #666;
    }
  }
`;

export const SelectedDomainsWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SelectedDomainsTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
`;

export const SelectedDomainsContainer = styled(FlexBox)`
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    max-height: 150px;
    overflow-y: auto;
  }
`;

export const DomainsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

export const DomainsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  align-items: self-end;
  overflow-x: hidden;
  overflow-y: visible;
`;
